import { MoneyConnectClientAPI } from "./axios-service-creator";

export const ProductAPI = {
  getPrimaryProducts: () => MoneyConnectClientAPI.get("/subscription/security"),
  getProductDetail: (payload) => MoneyConnectClientAPI.post("/subscription/security/detail", payload),
  getComplexProduct: () => MoneyConnectClientAPI.get("/subscription/security/complexProductList"),
  validateDocument: (payload) =>
    MoneyConnectClientAPI.post("/subscription/security/hnw-properties/validate/upload", payload),
  uploadDocument: (payload) => MoneyConnectClientAPI.post("/subscription/security/hnw-properties/upload", payload),
  getPortDetail: (payload) => MoneyConnectClientAPI.post("/subscription/ipo-port/search", payload),
  getSecurityDetail: (payload) => MoneyConnectClientAPI.post("/subscription/ipo-port/detail", payload),
  fetchAllBanner: () => MoneyConnectClientAPI.get("/subscription/banner"),
  upgradeGlobalSavingsAccount: (payload) =>
    MoneyConnectClientAPI.post("/subscription/security/redirect/global-saving", payload),
  openNewGlobalSavingsAccount: (payload) =>
    MoneyConnectClientAPI.post("/subscription/security/redirect/global-saving", payload),
  ackSubscriptionDisclaimer: (payload) => MoneyConnectClientAPI.post("/subscription/security/disclaimer/accept", payload),
};
